export const SET_BASE_ALERT_SOCKET = "SET_BASE_ALERT_SOCKET";
export const SET_BASE_ALERT = "SET_BASE_ALERT";
export const SET_CURRENT_ALERT_SOCKET = "SET_CURRENT_ALERT_SOCKET";
export const SET_CURRENT_ALERT = "SET_CURRENT_ALERT";
export const SHOW_HIDE_ALERTS = "SHOW_HIDE_ALERTS";
export const HIDE_ALERTS = "HIDE_ALERTS";
export const ADD_DEVICE_BY_SOCKET = "ADD_DEVICE_BY_SOCKET";
export const SHOW_ALERTS_BY_CURRENT_COMPANY = "SHOW_ALERTS_BY_CURRENT_COMPANY";

export function setBaseAlertSocket(data) {
    return {
        type: SET_BASE_ALERT_SOCKET,
        data
    }
}

export function setCurrentAlertSocket(data) {
    return {
        type: SET_CURRENT_ALERT_SOCKET,
        data
    }
}
export function setBaseAlert(data) {
    return {
        type: SET_BASE_ALERT,
        data
    }
}
export function setCurrentAlert(data) {
    return {
        type: SET_CURRENT_ALERT,
        data
    }
}
export function showHideAlerts(data) {
    return {
        type: SHOW_HIDE_ALERTS,
        data
    }
}
export function hideAlerts(data) {
    return {
        type: HIDE_ALERTS,
        data
    }
}
export function addDeviceBySocket(data) {
    return {
        type: ADD_DEVICE_BY_SOCKET,
        data
    }
}

export function showAlertsByCurrentCompany(data) {
    return {
        type: SHOW_ALERTS_BY_CURRENT_COMPANY,
        data
    }
}

